import { Component } from '@angular/core';
import { OnboardingCardComponent } from "../onboarding-card/onboarding-card.component";

@Component({
  selector: 'app-onboarding',
  standalone: true,
  imports: [OnboardingCardComponent],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent {

}
